import { render, staticRenderFns } from "./LabelProjectsTopSlot.vue?vue&type=template&id=10fe92f6"
import script from "./LabelProjectsTopSlot.vue?vue&type=script&lang=js"
export * from "./LabelProjectsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports